import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useGetWaitingMessages } from '@core/js/hooks/auth/hooks/useGetWaitingMessages';
import * as actions from '@core/js/hooks/auth/store/actions';

import { useAfterLoginAction } from '@interlayer/js/hooks/auth/hooks/useAfterLoginAction';
import { useFailedLoginAction } from '@interlayer/js/hooks/auth/hooks/useFailedLoginAction';
import { useSuccessLoginAction } from '@interlayer/js/hooks/auth/hooks/useSuccessLoginAction';
import { useFetchUserDetails } from '@interlayer/js/hooks/user/hooks/useFetchUserDetails';

import { useRegNavigationAfterLogin } from './useRegNavigationAfterLogin';

export const useFinishLogin = () => {
    const dispatch = useDispatch();
    const afterLoginAction = useAfterLoginAction();
    const fetchUserDetails = useFetchUserDetails();
    const failedLoginAction = useFailedLoginAction();
    const successLoginAction = useSuccessLoginAction();
    const getWaitingMessages = useGetWaitingMessages();
    const handlerNavigationAfterLogin = useRegNavigationAfterLogin();

    return useCallback(async ({ userName, isNavigateAfterLogin = true, isUpdateUserDetails = false }) => {
        try {
            const afterLoginActionData = await afterLoginAction();
            await successLoginAction({ userName, authType: 'credentials' });

            await getWaitingMessages();

            if (isUpdateUserDetails) {
                await fetchUserDetails();
            }

            if (isNavigateAfterLogin) {
                handlerNavigationAfterLogin({ userDetails: afterLoginActionData?.[0].userData });
            }

            dispatch(actions.setIsLoginInProcess(false));
        } catch (error) {
            failedLoginAction(error);
            dispatch(actions.setIsLoginInProcess(false));

            return Promise.reject(error);
        }
    }, [
        afterLoginAction,
        dispatch,
        failedLoginAction,
        getWaitingMessages,
        handlerNavigationAfterLogin,
        successLoginAction,
        fetchUserDetails
    ]);
};
